import { render, staticRenderFns } from "./NewBook.vue?vue&type=template&id=22c6b44e&"
import script from "./NewBook.vue?vue&type=script&lang=js&"
export * from "./NewBook.vue?vue&type=script&lang=js&"
import style0 from "./NewBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports